import React, { FunctionComponent } from 'react'
import { ViewStyle } from 'react-native'
import Svg, { Circle, ClipPath, Defs, G, LinearGradient, Mask, RadialGradient, Rect, Stop } from 'react-native-svg'

type AiVoiceBackgroundProps = {
  style?: ViewStyle
}

export const AiVoiceBackground: FunctionComponent<AiVoiceBackgroundProps> = ({ style }) => {
  return (
    <Svg width='100%' height='100%' viewBox='0 0 375 812' fill='none' preserveAspectRatio='none' style={style}>
      <G clipPath='url(#clip0_2_2)'>
        <Rect width='375' height='812' fill='url(#paint0_linear_2_2)' />
        <Circle cx='217' cy='496' r='312' fill='url(#paint1_radial_2_2)' fillOpacity='0.55' />
        <Circle cx='26' cy='762' r='312' fill='url(#paint2_radial_2_2)' fillOpacity='0.6' />
        <Rect width='375' height='812' fill='black' fillOpacity='0.15' />
        <Mask
          id='mask0_2_2'
          style={{
            maskType: 'alpha',
          }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='564'
          width='375'
          height='248'
        >
          <Rect y='564' width='375' height='248' fill='url(#paint3_linear_2_2)' />
        </Mask>
        <G mask='url(#mask0_2_2)'>
          <Rect
            width='375'
            height='252'
            transform='translate(0 560)'
            fill='url(#paint4_linear_2_2)'
            fillOpacity='0.3'
          />
        </G>
      </G>
      <Defs>
        <LinearGradient id='paint0_linear_2_2' x1='-67' y1='-74.5' x2='472.5' y2='641' gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#042A5F' />
          <Stop offset='1' stopColor='#0A7DAA' />
        </LinearGradient>
        <RadialGradient
          id='paint1_radial_2_2'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(217 496) rotate(90) scale(312)'
        >
          <Stop offset='0.230769' stopColor='#227BD5' />
          <Stop offset='0.644231' stopColor='#227BD5' stopOpacity='0.5' />
          <Stop offset='1' stopColor='#737373' stopOpacity='0' />
        </RadialGradient>
        <RadialGradient
          id='paint2_radial_2_2'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(26 762) rotate(90) scale(312)'
        >
          <Stop offset='0.230769' stopColor='#B17FA3' />
          <Stop offset='0.644231' stopColor='#B17FA3' stopOpacity='0.5' />
          <Stop offset='1' stopColor='#737373' stopOpacity='0' />
        </RadialGradient>
        <LinearGradient
          id='paint3_linear_2_2'
          x1='187.5'
          y1='557.883'
          x2='187.5'
          y2='812'
          gradientUnits='userSpaceOnUse'
        >
          <Stop offset='0.0744128' stopColor='#D9D9D9' stopOpacity='0' />
          <Stop offset='0.30027' stopColor='#737373' stopOpacity='0.5' />
          <Stop offset='0.528546' stopColor='#737373' />
        </LinearGradient>
        <LinearGradient
          id='paint4_linear_2_2'
          x1='174.956'
          y1='-43.8261'
          x2='425.869'
          y2='55.8924'
          gradientUnits='userSpaceOnUse'
        >
          <Stop stopColor='#001A70' />
          <Stop offset='1' stopColor='#00515C' />
        </LinearGradient>
        <ClipPath id='clip0_2_2'>
          <Rect width='375' height='812' fill='white' />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default AiVoiceBackground
